import { defaultTheme } from '@sleepstation/themes-public-site'
import { createTheme } from '@sleepstation/utils'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const infoCardThemeNegative = createTheme(
  `InfoCardNegative`,
  defaultTheme.api,
  {
    colors: {
      backgroundPrimary: `red`,
      backgroundPrimaryStart: `red`,
      backgroundPrimaryEnd: `red`,
      title: `white`,
      bodyBackground: `redPale`,
      highlight: `red`,
    },
  },
  defaultTheme
)

export default infoCardThemeNegative
